/**
 * A chat attachment, opened as a lightbox.
 *
 * The framing is the dialog's own: a transparent, ring-less panel that is only as big as the
 * picture inside it, so the image sits in the viewport rather than in a card. The picture itself
 * is the body the Documents preview draws (`features/documents/components/preview-bodies/`), so
 * the two surfaces show an image the same way and only their framing differs.
 */

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ImagePreviewBody } from "@/features/documents/components/preview-bodies/image-preview-body";

export type AttachmentPreviewDialogItem = {
  fileName: string;
  url: string;
};

export function AttachmentPreviewDialog({
  attachment,
  onOpenChange,
}: {
  attachment: AttachmentPreviewDialogItem | null;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={Boolean(attachment)} onOpenChange={onOpenChange}>
      <DialogContent className="w-fit max-w-[calc(100vw-2rem)] overflow-hidden bg-transparent p-0 shadow-none ring-0 sm:max-w-[calc(100vw-4rem)]">
        <DialogTitle className="sr-only">
          {attachment?.fileName ?? "Attachment preview"}
        </DialogTitle>
        {attachment ? (
          <ImagePreviewBody
            url={attachment.url}
            name={attachment.fileName}
            className="max-h-[calc(100vh-2rem)] max-w-[calc(100vw-2rem)] p-3 sm:max-h-[calc(100vh-4rem)] sm:max-w-[calc(100vw-4rem)] sm:p-4"
            imageClassName="max-h-[calc(100vh-3.5rem)] max-w-[calc(100vw-3.5rem)] sm:max-h-[calc(100vh-6rem)] sm:max-w-[calc(100vw-6rem)]"
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
